import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../types"
import { useApi } from "../../../../../../utils"

export function useShopTransaction() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/shop-transaction?only_active=true")
    .then((res: SuccessFetch<{
      payload: {
        shop_transaction_id: number
        shop_transaction_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.shop_transaction_name, value: item.shop_transaction_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)
    
    api.get("/shop-transaction?only_active=true")
    .then((res: SuccessFetch<{
      payload: {
        shop_transaction_id: number
        shop_transaction_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.shop_transaction_name, value: item.shop_transaction_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}